import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var WarningAmber = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 5.99 19.53 19H4.47L12 5.99M12 2 1 21h22L12 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 16h-2v2h2zm0-6h-2v5h2z"
  }));
});
WarningAmber.displayName = 'WarningAmber';
export var WarningAmberDimensions = {
  height: 24,
  width: 24
};